import { Record } from "../../components/record/Record";
import { EntityForm } from "../../components/entityForm/EntityForm";
import { Groups } from "../../components/groups/Groups";
import { GapsScreen } from "./GapsScreen";
import { GapPriorityFormContent } from "./GapPriorityFormContent";
import { GapPriorityDetailHeader } from "./GapPriorityDetailHeader";
import { GAP_PRIORITY_ENTITY, gapPriorityFieldsQuery, gapPriorityOptions } from "./gapsOptions";

export const gapsRoutes = [
    {
        path: "/gaps",
        element: <GapsScreen />,
    },
    {
        path: `/${GAP_PRIORITY_ENTITY}/create`,
        element: (
            <Record
                entity={GAP_PRIORITY_ENTITY}
                type="create"
                fieldsQuery={gapPriorityFieldsQuery}
                body={<EntityForm groupsOptions={gapPriorityOptions.groupsOptions} component={<GapPriorityFormContent />} />}
            />
        ),
    },
    {
        path: `/${GAP_PRIORITY_ENTITY}/:id/update`,
        element: (
            <Record
                entity={GAP_PRIORITY_ENTITY}
                type="update"
                fieldsQuery={gapPriorityFieldsQuery}
                body={<EntityForm component={<GapPriorityFormContent />} />}
            />
        ),
    },
    {
        path: `/${GAP_PRIORITY_ENTITY}/:id/detail`,
        element: (
            <Record
                entity={GAP_PRIORITY_ENTITY}
                type="detail"
                fieldsQuery={gapPriorityFieldsQuery}
                header={<GapPriorityDetailHeader />}
                body={<Groups />}
            />
        ),
    },
];
